module.exports = __webpack_public_path__ + "img/quand_14.6211f2a0.png";